/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scanned_Pages_Temporary_TitleInputs */

const en_mobile_scanned_pages_temporary_title = /** @type {(inputs: Mobile_Scanned_Pages_Temporary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanned pages`)
};

const es_mobile_scanned_pages_temporary_title = /** @type {(inputs: Mobile_Scanned_Pages_Temporary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas escaneadas`)
};

/**
* | output |
* | --- |
* | "Scanned pages" |
*
* @param {Mobile_Scanned_Pages_Temporary_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scanned_pages_temporary_title = /** @type {((inputs?: Mobile_Scanned_Pages_Temporary_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scanned_Pages_Temporary_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scanned_pages_temporary_title(inputs)
	return en_mobile_scanned_pages_temporary_title(inputs)
});